<div
  class="phone-number"
  [formGroup]="phoneNumberForm"
  [ngClass]="inputClasses()">
  @if (label()) {
    <label class="phone-number__label">
      {{ label() | translate }}
      <span class="phone-number__required">*</span>
    </label>
  }

  <div
    class="phone-number__field"
    [class.phone-number__field--error]="hasErrors"
    [class.phone-number__field--filled]="!!f['mobile_number'].value"
    [class.phone-number__field--open]="showPrefixMenu">
    <div class="phone-number__prefix-wrapper">
      <button
        type="button"
        class="phone-number__prefix"
        [disabled]="disabled"
        [attr.aria-expanded]="showPrefixMenu"
        aria-haspopup="listbox"
        (click)="togglePrefixMenu($event)">
        <i [class]="'flags flag:' + selectedCountryCode + ' phone-number__flag'"></i>
        <span class="phone-number__dial-code">{{ f['prefix'].value }}</span>
        <i
          class="iconsax phone-number__chevron"
          [attr.icon-name]="showPrefixMenu ? 'chevron-up' : 'chevron-down'"></i>
      </button>
    </div>

    @if (showPrefixMenu) {
      <div class="phone-number__prefix-menu" role="listbox">
        <div class="phone-number__search-wrap">
          <i
            class="iconsax phone-number__search-icon"
            icon-name="search-normal-2"></i>
          <input
            class="phone-number__search"
            type="text"
            [(ngModel)]="searchTerm"
            [ngModelOptions]="{ standalone: true }"
            [placeholder]="'global.search' | translate"
            (click)="$event.stopPropagation()" />
        </div>

        <div class="phone-number__prefix-list custom-scrollbar">
          @for (option of filteredCountryCodes; track option.label) {
            <button
              type="button"
              class="phone-number__prefix-option"
              role="option"
              [class.phone-number__prefix-option--active]="
                isSelectedCountry(option)
              "
              (click)="selectCountry(option, $event)">
              <span class="phone-number__prefix-option-main">
                <i [class]="'flags flag:' + getCountryCode(option)"></i>
                <span>{{ getCountryName(option) }}</span>
              </span>
              <span class="phone-number__prefix-option-code">
                +{{ getDialCode(option) }}
              </span>
            </button>
          } @empty {
            <span class="phone-number__prefix-empty">
              {{ 'global.noResult' | translate }}
            </span>
          }
        </div>
      </div>
    }

    <span class="phone-number__divider"></span>

    <input
      class="phone-number__input"
      type="tel"
      formControlName="mobile_number"
      [placeholder]="placeholder() | translate"
      pwjOnlyNumber
      (focus)="onMobileFocus()"
      (blur)="onMobileBlur()" />
  </div>

  @if (hasErrors) {
    <div class="phone-number__errors">
      @for (error of messages() | keyvalue; track error.key) {
        @if (mobileErrors?.[error.key]) {
          <span class="phone-number__error">{{
            error.value | translate
          }}</span>
        }
      }
    </div>
  }
</div>
